import React from 'react';
import AuthScreen from '../components/auth/AuthScreen';

/** `/register/email` — the email form (components/auth/AuthScreen). `/register` itself is ENTER (sign-up v3). */
export default function RegisterPage() {
  return <AuthScreen screen="register" />;
}
